module.exports = ".custom-control .custom-control-input{\r\n    opacity: 0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/activities/activity-form/activity-form.component.css
// module id = ./src/app/Pages/activities/activity-form/activity-form.component.css
// module chunks = main